import {
    HTTP_STATUS_CODE_BAD_REQUEST,
    HTTP_STATUS_CODE_CONTINUE,
    HTTP_STATUS_CODE_INTERNAL_SERVER_ERROR,
    HTTP_STATUS_CODE_MULTIPLE_CHOICES,
    HTTP_STATUS_CODE_OK,
} from '@/constants';

export const useApiResponse = () => {
    return (status: Response['status']) => ({
        info: status >= HTTP_STATUS_CODE_CONTINUE && status < HTTP_STATUS_CODE_OK,
        ok: status >= HTTP_STATUS_CODE_OK && status < HTTP_STATUS_CODE_MULTIPLE_CHOICES,
        redirect:
            status >= HTTP_STATUS_CODE_MULTIPLE_CHOICES && status < HTTP_STATUS_CODE_BAD_REQUEST,
        error:
            status >= HTTP_STATUS_CODE_BAD_REQUEST &&
            status < HTTP_STATUS_CODE_INTERNAL_SERVER_ERROR,
        server: status >= HTTP_STATUS_CODE_INTERNAL_SERVER_ERROR,
    });
};
